export const OPEN_COMMAND_PALETTE_EVENT = 'holzcom-open-command-palette';
